module.exports = __webpack_public_path__ + "static/media/STAF_bokmål_sentrert logo_pos(svart).f95fc2e8.pdf";